import { useRef } from 'react'

export function useDoubleClick<T>(
  onClick?: React.MouseEventHandler<T>,
  onDoubleClick?: React.MouseEventHandler<T>,
) {
  const singleClickTimer = useRef<NodeJS.Timeout | undefined>(undefined)

  const clearTimer = () => {
    if (singleClickTimer) {
      clearTimeout(singleClickTimer.current)
      singleClickTimer.current = undefined
    }
  }

  const handleClick: React.MouseEventHandler<T> = (e) => {
    if (!onDoubleClick) {
      if (onClick) {
        onClick(e)
      }
      return
    }

    if (singleClickTimer.current === undefined) {
      singleClickTimer.current = setTimeout(function () {
        clearTimer()
        if (onClick) {
          onClick(e)
        }
      }, 400)
    } else {
      clearTimer()
      if (onDoubleClick) {
        onDoubleClick(e)
      }
    }
  }

  return handleClick
}
